export type OgrFormatEntry =
  | { type: 'single'; ext: string }
  | { type: 'primary'; ext: string; required: string[]; optional: string[] }

export const OGR_FORMATS: OgrFormatEntry[] = [
  { type: 'primary', ext: 'shp', required: ['shx', 'dbf'], optional: ['prj', 'cpg', 'sbn', 'sbx'] },
  { type: 'single', ext: 'geojson' },
  { type: 'single', ext: 'json' },
  { type: 'single', ext: 'gpkg' },
  { type: 'single', ext: 'kml' },
  { type: 'single', ext: 'dxf' },
  { type: 'single', ext: 'gml' },
  { type: 'single', ext: 'tab' },
  { type: 'single', ext: 'mif' },
  { type: 'single', ext: 'csv' },
]

export const ALL_OGR_EXTENSIONS: string[] = OGR_FORMATS.flatMap((f) =>
  f.type === 'primary' ? [f.ext, ...f.required, ...f.optional] : [f.ext],
)

export const OGR_ACCEPT_ATTR: string = ALL_OGR_EXTENSIONS.map((e) => `.${e}`).join(',')

export const COMPANION_EXTENSIONS = new Set(
  OGR_FORMATS.flatMap((f) => (f.type === 'primary' ? [...f.required, ...f.optional] : [])),
)

export const PRIMARY_EXTENSIONS = new Set(OGR_FORMATS.map((f) => f.ext))
